import client from './client';
import { User } from '../types';

export const otpApi = {
  request: (phone: string) =>
    client.post<{ status: string }>('/otp/request', { phone }).then((r) => r.data),
  verify: (phone: string, code: string) =>
    client
      .post<{ status: string; user: User }>('/otp/verify', { phone, code })
      .then((r) => r.data),
};
